<template>
  <v-main app>
    <v-navigation-drawer
      clipped
      app
      fixed
      :permanent="$vuetify.breakpoint.mdAndUp"
      style="z-index: 1"
    >
      <v-list>
        <v-list-item>
          <v-btn
            class="d-flex justify-start"
            block
            outlined
            color="primary"
            to="/admin/trello/boards"
          >
            <v-icon class="mr-4"> mdi-palette </v-icon>
            Boards
          </v-btn>
        </v-list-item>
        <v-list-item>
          <v-btn
            class="d-flex justify-start"
            block
            outlined
            color="primary"
            to="/admin/trello/cards"
          >
            <v-icon class="mr-4"> mdi-palette </v-icon>
            Cards
          </v-btn>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-container fluid>
      <router-view />
    </v-container>
  </v-main>
</template>
<script>
import AccountingApi from "@/api/accounting";
import AuthoriseXero from "@/views/Admin/Xero/AuthoriseXero.vue";
export default {
  props: {},
  components: {
    AuthoriseXero,
  },
  data() {
    return {
      isAuthenticated: false,
    };
  },
  async created() {
    this.$store.dispatch("contacts/loadContacts");
    this.$store.dispatch("trello/loadBoards");
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
// .sidebar {
//   margin-top: 112px !important;
// }
</style>
